import React, {useEffect, useState} from 'react';
import {
   ImageBackground,
   View,
   StyleSheet,
   Image,
   Text,
   TouchableOpacity,
   Dimensions,
   Platform,
} from 'react-native';
//import {AnimatedCircularProgress} from 'react-native-circular-progress';
import UICircularProgress from '../../components/circular-progress';
import {
   selectScreenOrientation,
   selectLandscapeSmallWebView,
} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';
import {
   FONT_FAMILY_REGULAR,
   FONT_FAMILY_MEDIUM,
   WHITE_ICON_HOVER_TINT_COLOR,
} from '../../utils/utils';

export const FinalTestReview = props => {
   const isPreTeastEnable = props.isPreTeastEnable;
   const percentage = isPreTeastEnable ? 100 : props.requiredPercentage;
   const title = 'Final Test Review';
   const subTitle =
      'We will now review the incorrect answers. Click OK to begin.';
   const mMessage = `A Score of ${percentage}% is required to pass.`;
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const Dimenesion = Dimensions.get('window');
   const width = Math.max(Dimenesion.width, Dimenesion.height);
   const height = Math.min(Dimenesion.width, Dimenesion.height);
   const isWeb = Platform.OS === 'web';
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const [isHoverBegenTest, setHoverBegenTest] = useState(false);
   const isPassed = false; //Only for design
   return (
      <View
         style={[
            {
               flex: 1,
               backgroundColor: '#000000',
               justifyContent: 'center',
               ...Platform.select({
                  web: {
                     flex: null,
                     height: '100%',
                  },
               }),
            },
            isWeb &&
               !isLandscapeMode &&
               !isLandscapeSmallWebView && {
                  ...Platform.select({
                     web: {
                        height: '100vw',
                        top: '100vh',
                        left: 0,
                        transform: 'rotate(-90deg)',
                        transformOrigin: 'left top',
                        width: '100vh',
                     },
                  }),
               },
         ]}>
         <ImageBackground
            source={require('../../assets/bg_final_test_new.png')}
            style={[
               styles.backgroundImage,
               {
                  ...Platform.select({
                     web: {
                        height: '100%',
                     },
                  }),
               },
            ]}>
            <View
               style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  resizeMode: 'contain',
                  alignItems: 'center',
                  opacity: 0.5,
                  //backgroundColor: 'yellow',
               }}
            />
            <View
               style={{
                  marginTop: isLandscapeMode ? height * 0.16 : height * 0.06,
                  marginBottom: isLandscapeMode ? height * 0.16 : height * 0.06,
                  alignItems: 'center',
                  justifyContent: 'center',
                  ...Platform.select({
                     web: {
                        marginBottom: 0,
                        marginTop: 0,
                        height: '100%',
                        paddingVertical: '5%',
                     },
                     android: {
                        flex: 1,
                        marginTop: isLandscapeMode ? null : height * 0.06,
                        marginBottom: isLandscapeMode ? null : height * 0.06,
                     },
                     ios: {
                        flex: 1,
                        marginTop: isLandscapeMode ? null : height * 0.06,
                        marginBottom: isLandscapeMode ? null : height * 0.06,
                     },
                     windows: {
                        flex: 1,
                        marginTop: isLandscapeMode ? null : height * 0.06,
                        marginBottom: isLandscapeMode ? null : height * 0.06,
                     },
                     macos: {
                        flex: 1,
                        marginTop: isLandscapeMode ? null : height * 0.06,
                        marginBottom: isLandscapeMode ? null : height * 0.06,
                     },
                  }),
               }}>
               <View
                  style={{
                     flexDirection: isLandscapeMode ? 'column' : 'row',
                     alignItems: 'center',
                     //backgroundColor: 'yellow',
                  }}>
                  <Image
                     source={require('../../assets/quiz_final_test.png')}
                     style={{
                        width: isLandscapeMode ? 104 : 40,
                        height: isLandscapeMode ? 104 : 40,
                        alignItems: 'center',
                     }}
                  />
                  <Text
                     style={{
                        marginTop: 5,
                        color: '#26E555',
                        fontSize: isLandscapeMode ? 32 : 28,
                        fontFamily: FONT_FAMILY_REGULAR,
                        marginLeft: isLandscapeMode ? 0 : 8,
                        alignSelf: 'center',
                        justifyContent: 'center',
                        fontWeight: '700',
                     }}>
                     {title}
                  </Text>
               </View>
               <Text
                  style={{
                     color: '#FFFFFF',
                     fontFamily: FONT_FAMILY_REGULAR,
                     fontWeight: isLandscapeMode ? '400' : '600',
                     fontSize: isLandscapeMode ? 24 : 20,
                     marginTop: isLandscapeMode ? 24 : 10,
                  }}>
                  {subTitle}
               </Text>
               <TouchableOpacity
                  /* style={{
                     marginTop: isLandscapeMode ? 200 : 0,
                  }} */
                  onMouseEnter={() => setHoverBegenTest(true)}
                  onMouseLeave={() => setHoverBegenTest(false)}
                  onPress={() => {
                     props.proceed();
                  }}>
                  <View
                     style={{
                        flexDirection: 'row',
                        width: isLandscapeMode
                           ? isPassed
                              ? width * 0.095
                              : width * 0.079
                           : isPassed
                           ? width * 0.113
                           : width * 0.094,
                        height: isLandscapeMode
                           ? height * 0.06
                           : height * 0.106,
                        backgroundColor: isHoverBegenTest
                           ? WHITE_ICON_HOVER_TINT_COLOR
                           : '#F2F5FF',
                        marginTop: isLandscapeMode ? 38 : 22,
                        borderRadius: 6,
                        justifyContent: 'center',
                        alignItems: 'center',
                        ...Platform.select({
                           web: {
                              marginBottom: isLandscapeMode ? 24 : 10,
                              height: isLandscapeMode
                                 ? height * 0.08
                                 : isLandscapeSmallWebView
                                 ? height * 0.106
                                 : 40,
                              width: isLandscapeMode
                                 ? isPassed
                                    ? width * 0.095
                                    : width * 0.079
                                 : isLandscapeSmallWebView
                                 ? isPassed
                                    ? width * 0.09
                                    : width * 0.09
                                 : 92,
                           },
                        }),
                     }}>
                     <Image
                        style={{
                           width: isLandscapeMode ? 24 : 18,
                           height: isLandscapeMode ? 24 : 18,
                        }}
                        source={require('../../assets/correct_begin_test.png')}
                     />
                     <Text
                        style={{
                           color: '#003DA5',
                           fontFamily: FONT_FAMILY_MEDIUM,
                           fontWeight: isLandscapeMode ? '500' : '700',
                           fontSize: isLandscapeMode ? 20 : 14,
                           marginLeft: 10,
                           height: !isLandscapeMode ? 18 : null,
                        }}>
                        OK
                     </Text>
                  </View>
               </TouchableOpacity>
            </View>
         </ImageBackground>
      </View>
   );
};

const styles = StyleSheet.create({
   backgroundImage: {
      flex: 1,
      resizeMode: 'contain', // or 'stretch'
      alignItems: 'center',
   },
});

export default FinalTestReview;
